import React, { ReactElement } from 'react';

import { LegacyPrimaryButton as PrimaryButton } from '@videoblocks/storywind';

export interface MyFoldersTopLevelControlsPropTypes {
  onSearch: React.ChangeEventHandler<HTMLInputElement>;
  onCreateNewFolder: () => void;
}

const MyFoldersTopLevelControls = ({
  onSearch,
  onCreateNewFolder,
}: MyFoldersTopLevelControlsPropTypes): ReactElement => {
  return (
    <div className="flex items-center">
      <div className="flex flex-wrap h-10">
        <input
          type="text"
          placeholder="Search..."
          className="w-full md:w-96 mr-4 p-1 border border-gray-400 rounded"
          onChange={onSearch}
          aria-label="Search for folders"
        />

        <PrimaryButton className="m-0" onClick={onCreateNewFolder}>
          Create New Folder
        </PrimaryButton>
      </div>
    </div>
  );
};

export default MyFoldersTopLevelControls;
